export const GET_JOB_POSITIONS = 'GET_JOB_POSITIONS';
export const LOADING_JOB_POSITIONS = 'LOADING_JOB_POSITIONS';
export const SAVE_LOADING_JOB_POSITIONS = 'SAVE_LOADING_JOB_POSITIONS';
export const FORM_FAIL = "FORM_FAIL";
export const JOB_POSITIONS_FAIL = 'JOB_POSITIONS_FAIL';
